module.exports = __webpack_public_path__ + "media/images/gallery/constellations/equuleus/equ_vis-5269be4a5404d655593543d6583f46ff.jpg";